<template>
  <div style="padding-left:20px">
    <h1 class="examText1">我的消息</h1>
    <el-card shadow="never" class="aui-card--fill">
    <div>
      <el-input v-model="receivingUnit" style="width:200px;margin-right:15px" clearable placeholder="接收单位" ></el-input>
      <el-select v-model="serviceType" placeholder="消息类型" style="width:200px;margin-right:15px" clearable>
         <el-option v-for="item in options"  :key="item.value" :label="item.label" :value="item.value" ></el-option>
      </el-select>
      <el-select v-model="isReade" placeholder="是否已读" style="width:200px;margin-right:15px" clearable>
         <el-option v-for="item in options1"  :key="item.value" :label="item.label" :value="item.value" ></el-option>
      </el-select>
      <el-button type="primary" @click="init()">查询</el-button>
      <el-button type='danger' @click="resetHandle()">重置</el-button>
    </div>
    <el-table :data="dataList" border style="width: 100%;margin-top:20px">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" ></el-table-column>
      <el-table-column  prop="serviceType" min-width="150" label="消息类型" header-align="center" align="center" >
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.serviceType==2" size="mini"  effect="plain">反馈</el-tag>
              <el-tag type="danger" v-if="scope.row.serviceType==1" size="mini"  effect="plain">举报</el-tag>
              <el-tag type="primary" v-if="scope.row.serviceType==0" size="mini"  effect="plain">咨询</el-tag>
            </template>
      </el-table-column>
          <el-table-column prop="receivingUnit"  min-width="180" label="接收单位" header-align="center" align="center" ></el-table-column>
          <el-table-column prop="isHandle"  min-width="120" label="处理结果" header-align="center" align="center" >
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isHandle==1" size="mini"  effect="plain">已处理</el-tag>
              <el-tag type="info" v-if="scope.row.isHandle==0" size="mini"  effect="plain">未处理</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="isReade"  min-width="120" label="是否已读" header-align="center" align="center" >
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isReade==1" size="mini"  effect="plain">已读</el-tag>
              <el-tag type="info" v-if="scope.row.isReade==0" size="mini"  effect="plain">未读</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate"  min-width="180" label="咨询/举报时间" header-align="center" align="center" ></el-table-column>
          <el-table-column prop="handleDate"  min-width="180" label="处理时间" header-align="center" align="center" ></el-table-column>
      <el-table-column label="操作" width="120" align='center' fixed="right">
        <template slot-scope="scope">
          <div class="ishow">
            <el-button  type="text" size="small"  @click="view(scope.row)">查看</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:right;margin-top:20px;"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      background
      :total="total"
      layout="total, sizes, prev, pager, next"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
    </el-pagination>
    </el-card>
    <el-dialog  :title="info.serviceType==1?'举报详情':'咨询详情'" :visible.sync="zjVisible"  width="700px">
      <ul class="infodiv">
        <li><div class="left">{{info.serviceType==1?'举报时间':'咨询时间'}}：</div><div class="right">{{info.createDate}}</div></li>
        <li><div class="left">{{info.serviceType==1?'举报课程':'咨询课程'}}：</div><div class="right">{{info.teachingName}}</div></li>
        <li><div class="left">{{info.serviceType==1?'举报内容':'咨询内容'}}：</div><div class="right">{{info.questionContent}}</div></li>
        <li><div class="left">处理时间：</div><div class="right">{{info.handleDate}}</div></li>
        <li><div class="left">回复单位：</div><div class="right">{{info.receivingUnit}}</div></li>
        <li><div class="left" >处理内容：</div><div class="right">{{info.reply}}</div></li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zjVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'examHistory',
  data () {
    return {
      dataList: [],
      zjVisible: false,
      page: 1,
      total: 0,
      limit: 10,
      isReade: '',
      isExamHistoryView: false,
      serviceType: '',
      receivingUnit: '',
      options: [{
        value: '0',
        label: '咨询'
      }, {
        value: '1',
        label: '举报'
      }],
      options1: [{
        value: '0',
        label: '未读'
      }, {
        value: '1',
        label: '已读'
      }],
      info: {}
    }
  },
  methods: {
    init () {
      let obj = { page: this.page, limit: this.limit, receivingUnit: this.receivingUnit, isNotFeedback: true, serviceType: this.serviceType, isReade: this.isReade, type: 'msg' }
      this.$get('/training/customerService/page', obj).then(res => {
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.init()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.init()
    },
    // 点击查看
    view (row) {
      this.info = row
      this.yd(row.id)
      this.zjVisible = true
    },
    yd (id) {
      this.$get('/training/customerService/getInfo?id=' + id).then(res => {
        this.init()
      })
    },
    resetHandle () {
      this.receivingUnit = ''
      this.serviceType = ''
      this.isReade = ''
      this.page = 1
      this.init()
    }
  }
}
</script>
<style scoped>
  .examText1{
    font-size: 22px;padding-bottom: 20px;
  }
   div /deep/ .el-table th{background: #f5f7fa;}
   div /deep/ .el-dialog__body{padding:5px 20px}
   .infodiv li{overflow: hidden;line-height: 30px;padding:3px 0}
   .infodiv .left{width: 80px;float: left;text-align: right;font-weight: bold;}
   .infodiv .right{float: left;color: #666;width: 560px;}
</style>
